<template>
  <div>
    <Messages id="thread-messages" :thread-id="threadId" />
  </div>
</template>

<script>
// import useThreadList from './useThreadList'
// import Panel from 'components/common/Panel'
// import { ref, watch } from '@vue/composition-api'
import Messages from './Messages'

export default {
  name: 'ChatThreadMessages',
  components: { Messages },
  props: {
    threadId: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    return {}
  },
}
</script>
